import { ArrowLeft, Home } from "lucide-react";
import { Link, useNavigate } from "react-router";

import { useDocumentTitle } from "../use-document-title";
import styles from "./not-found.module.css";
import { WaveBackground } from "./wave-background";

/**
 * Catch-all 404 — registered as a `path: "*"` child of the root route, so
 * it renders inside `<RootLayout>`'s `<Outlet>` like every other page: the
 * nav rail, header, and identity control stay visible instead of the user
 * hitting a bare, shell-less error screen. NOT built on `<StubPage>` — that
 * component's left-aligned title/description block doesn't match this
 * page's actual layout (one fully centered composition, matching the real
 * reference error page from a sibling app in this monorepo, WaveBackground
 * included), so everything here is custom.
 */
export function NotFoundPage() {
  useDocumentTitle("Page not found");
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <WaveBackground />
      <div className={styles.visual}>
        <p className={styles.code} aria-hidden="true">
          404
        </p>
        <div className={styles.bar} aria-hidden="true" />
        <h1 className={styles.heading}>Page Not Found</h1>
        <p className={styles.message}>
          Sorry, the page you&rsquo;re looking for doesn&rsquo;t exist or has
          been moved.
        </p>
        <Link to="/" className={styles.homeButton}>
          <Home size={16} />
          Go Home
        </Link>
        <button
          type="button"
          className={styles.backButton}
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={14} />
          Go Back
        </button>
        <p className={styles.footer}>Error Code: 404</p>
      </div>
    </div>
  );
}
